import apiClient from '../authentication/utils/core/axios';

// Monetization API service (mirrors backend endpoints, 2026-07-09)
const MonetizationAPI = {
  // GET /monetization/config -- public, tells the frontend whether real
  // charges can fire and which Stripe publishable key to use.
  fetchConfig: async () => {
    const res = await apiClient.get('/monetization/config');
    return res.data;
  },

  // POST /monetization/connect/onboard
  onboardConnect: async () => {
    const res = await apiClient.post('/monetization/connect/onboard');
    if (res.status !== 200) throw new Error('Failed to start creator onboarding');
    return res.data;
  },

  // GET /monetization/connect/status
  fetchConnectStatus: async () => {
    const res = await apiClient.get('/monetization/connect/status');
    return res.data;
  },

  // GET /groups/{groupId}/pricing -- public
  fetchGroupPricing: async (groupId) => {
    const res = await apiClient.get(`/groups/${groupId}/pricing`);
    return res.data;
  },

  // POST /groups/{groupId}/pricing
  setGroupPricing: async (groupId, pricing) => {
    const res = await apiClient.post(`/groups/${groupId}/pricing`, pricing);
    if (res.status !== 200) throw new Error('Failed to update pricing');
    return res.data;
  },

  // POST /groups/{groupId}/subscribe
  subscribeToGroup: async (groupId) => {
    const res = await apiClient.post(`/groups/${groupId}/subscribe`);
    if (res.status !== 200) throw new Error('Failed to start checkout');
    return res.data;
  },

  // GET /groups/{groupId}/subscription
  fetchMySubscription: async (groupId) => {
    const res = await apiClient.get(`/groups/${groupId}/subscription`, {
      validateStatus: (s) => [200, 404].includes(s),
    });
    if (res.status === 404) return null;
    return res.data;
  },

  // POST /groups/{groupId}/cancel-subscription
  cancelSubscription: async (groupId) => {
    const res = await apiClient.post(`/groups/${groupId}/cancel-subscription`);
    if (res.status !== 204) throw new Error('Failed to cancel subscription');
    return true;
  },

  // GET /monetization/my-subscriptions
  fetchMySubscriptions: async () => {
    const res = await apiClient.get('/monetization/my-subscriptions');
    return res.data;
  },

  // GET /monetization/earnings/{userId} -- superseded by fetchCreatorDashboard
  // below for the real dashboard, kept for any other existing caller.
  fetchEarnings: async (userId) => {
    const res = await apiClient.get(`/monetization/earnings/${userId}`);
    return res.data;
  },

  // GET /monetization/creator-dashboard/{userId} -- the full dashboard payload
  // (overview, per-group breakdown, estimate, audience, content trends, insights).
  fetchCreatorDashboard: async (userId) => {
    const res = await apiClient.get(`/monetization/creator-dashboard/${userId}`);
    return res.data;
  },
};

export default MonetizationAPI;
